package org.ssoft.server.boundary.icons

import kotlinx.serialization.ExperimentalSerializationApi
import kotlinx.serialization.json.Json
import kotlinx.serialization.modules.SerializersModule
import kotlinx.serialization.modules.polymorphic
import kotlinx.serialization.protobuf.ProtoBuf
import org.ssoft.common.server.icons.IconIO

@OptIn(ExperimentalSerializationApi::class)
val PROTO_INSTANCE_ICONS by lazy {
    ProtoBuf {
//        encodeDefaults = true
        serializersModule = SerializersModule {
            polymorphic(IconIO::class) {
                subclass(IconIO.Random::class, IconIO.Random.serializer())
                subclass(IconIO.Query::class, IconIO.Query.serializer())
            }
        }
    }
}

@Suppress("unused")
val JSON_SERIALIZER_ICONS = Json {
    ignoreUnknownKeys = true
    coerceInputValues = true
    prettyPrint = false
    isLenient = true
    classDiscriminator = "#class"
}